import { useState, useEffect } from 'react';
import Layout from "../../components/layout/Layout";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { colleaguesColumns } from "../../util/colleaguesTableData";
import {
  ActionContainer,
  AddUser,
  DataGridContainer,
  DataGridWrapper,
} from "./style";
import { Link, useLocation } from "react-router-dom";
import { getColleagues } from '../../api/colleaguesService';
import { getEvents } from '../../api/eventsService';
import { getPermissions } from '../../api/permissionsService';
import { getPublications } from '../../api/magazineService';

const Permissions = () => {

  const location = useLocation();

  const [users, setUsers] = useState([]);
  const [events, setEvents] = useState<any[]>([]);
  const [publications, setPublications] = useState<any[]>([]);
  const [permissions, setPermissions] = useState<any[]>([]);

  useEffect(() => {
    getEvents().then(setEvents).catch((err: any) => console.log(err.message));
    getPublications().then(setPublications).catch((err: any) => console.log(err.message));
    getPermissions().then(setPermissions).catch((err: any) => console.log(err.message));
    getColleagues().then(setUsers).catch((err) => console.log(err.message));
  }, []);

  const actions: GridColDef[] = [
    {
      field: "permission",
      headerName: "Access",
      width: 320,
      renderCell: (params: any) => {
        const permission: any = permissions.find((item: any) => String(item.user_id) === String(params.id));
        const assignedEvents = events.filter((item) =>
          (permission?.events || []).some((id: number) => Number(id) === Number(item.id))
        );
        const assignedPublications = publications.filter((item) =>
          (permission?.publications || []).some((id: number) => Number(id) === Number(item.id))
        );

        if (!assignedEvents.length && !assignedPublications.length) {
          return <ActionContainer><span>—</span></ActionContainer>;
        }

        return (
          <ActionContainer>
            <div className="inputField" style={{ textAlign: 'left', fontSize: 13 }}>
              {assignedEvents.length > 0 && (
                <div style={{ marginBottom: 6 }}>
                  <strong>Events:</strong>
                  {assignedEvents.map((item) => (
                    <div key={item.id}>{item.title}</div>
                  ))}
                </div>
              )}
              {assignedPublications.length > 0 && (
                <div>
                  <strong>Publications:</strong>
                  {assignedPublications.map((item) => (
                    <div key={item.id}>{item.name}</div>
                  ))}
                </div>
              )}
            </div>
          </ActionContainer>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 230,
      renderCell: (params: any) => {
        const permission: any = permissions.find((item: any) => item.user_id == params.id)
        return (
          <ActionContainer>
            <Link
              to={`${location.pathname}/${params.row.id}`}
              state={{ ...params.row }}
              style={{ textDecoration: "none" }}
            >
              <button className="btn viewBtn">Edit</button>
            </Link>
          </ActionContainer>
        );
      },
    },
  ];

  return (
    <Layout>
      <AddUser>
        <h1 className="title">User access</h1>
        <p style={{ margin: '8px 0 0', fontSize: 14, color: '#666', maxWidth: 720 }}>
          Module access is controlled by role (Admin, Product manager, Sales manager).
          Use this page to scope which <strong>events</strong> and <strong>publications</strong> a user can see in ops and magazine lists.
          Product managers with no publication restriction see the full catalog.
        </p>
        {/* <Link
          to={`${location.pathname}/new`}
          state={{ type }}
          style={{ textDecoration: "none" }}
        >
          <button className="add">Add Colleague</button>
        </Link> */}
      </AddUser>
      <DataGridWrapper>
        <DataGridContainer>
          <DataGrid
            style={{ backgroundColor: "white" }}
            rows={users}
            columns={
              colleaguesColumns.concat(actions)
            }
            pageSize={10}
            rowsPerPageOptions={[10]}
            rowHeight={120}
          // checkboxSelection
          />
        </DataGridContainer>
      </DataGridWrapper>
    </Layout>
  );
};

export default Permissions;
